module.exports = __webpack_public_path__ + "img/girl2.685890b5.jpg";